module.exports = __webpack_public_path__ + "img/cv.001fc0d4.svg";